import { CustomerBooking, Maybe } from "rsl-api-106/lib/types";

import { getCurrencySymbol } from "./currencies";

export const getDiscountedPrice = (
  price: number,
  discount?: number
): string => {
  if (!discount) {
    return price.toString();
  } else {
    return (price - price * (discount / 100)).toFixed(2);
  }
};

export const getDiscountByPrices = (
  lowerPrice: number,
  higherPrice: number
): string => {
  return (((higherPrice - lowerPrice) / higherPrice) * 100).toFixed(2);
};

export const getTotalReservationsPrice = (
  reservations?: Maybe<Maybe<CustomerBooking>[]> | undefined
): string => {
  let total: number = 0;
  let currencySymbol = "";
  if (reservations) {
    reservations.forEach((reservation) => {
      total += reservation?.totalAmount?.amount || 0;
      currencySymbol = reservation?.totalAmount?.currencyCode!!;
    });
  }
  return `${total.toFixed(2)}${getCurrencySymbol(currencySymbol)}`;
};
